import { Dispatch } from "redux";
import {
  getSprints,
  createSprint,
  updateSprint,
  deleteSprint,
  getSprintByPojectId,
} from "../../services/SprintService";
import { Sprint } from "../../types/Sprint";

export enum SprintActionType {
  FETCH_SPRINTS = "FETCH_SPRINTS",
  ADD_SPRINT = "ADD_SPRINT",
  EDIT_SPRINT = "EDIT_SPRINT",
  DELETE_SPRINT = "DELETE_SPRINT",
  FETCH_SPRINTS_PROJECTID = "FETCH_SPRINTS_PROJECTID",
}

export interface FetchSprints {
  type: SprintActionType.FETCH_SPRINTS;
  data: Sprint[];
}

export interface AddSprint {
  type: SprintActionType.ADD_SPRINT;
  data: Sprint;
}

export interface EditSprint {
  type: SprintActionType.EDIT_SPRINT;
  data: Sprint;
}

export interface DeleteSprint {
  type: SprintActionType.DELETE_SPRINT;
  data: number;
}

export interface FetchSprintsProjecId {
  type: SprintActionType.FETCH_SPRINTS_PROJECTID;
  data: Sprint[];
}

export type SprintAction =
  | FetchSprints
  | AddSprint
  | EditSprint
  | DeleteSprint
  | FetchSprintsProjecId;

export const fetchSprints = () => async (dispatch: Dispatch) => {
  const data = await getSprints();
  dispatch<FetchSprints>({ type: SprintActionType.FETCH_SPRINTS, data });
};

export const addSprint = (sprint: Sprint) => async (dispatch: Dispatch) => {
  const response = await createSprint(sprint);
  dispatch<AddSprint>({
    type: SprintActionType.ADD_SPRINT,
    data: response.data.data,
  });
};

export const editSprint =
  (id: number, sprint: Sprint) => async (dispatch: Dispatch) => {
    const response = await updateSprint(id, sprint);
    dispatch<EditSprint>({
      type: SprintActionType.EDIT_SPRINT,
      data: response.data.data,
    });
  };

export const deleteSprintById = (id: number) => async (dispatch: Dispatch) => {
  await deleteSprint(id);
  dispatch<DeleteSprint>({ type: SprintActionType.DELETE_SPRINT, data: id });
};

export const fetchSprintsByProject =
  (projectId: number) => async (dispatch: Dispatch) => {
    try {
      const response = await getSprintByPojectId(projectId);

      dispatch<FetchSprintsProjecId>({
        type: SprintActionType.FETCH_SPRINTS_PROJECTID,
        data: response.data.data,
      });
    } catch (error) {
      console.error("Error fetching filtered Sprints", error);
    }
  };
